import React, { useState, useEffect } from 'react';
import "./DynamicSelect.css";
import data from './symbols_mini.json';
import { getCycle } from './lookalikes';
//import Create from './create';

export default function DynamicSelect(props) {
  const [options, setOptions] = useState([
    { value: 'option1', label: 'Option 1' },
  ]);

  useEffect(() => {
    var prep = '';
    {props.search.split('').map((char, index) => (
        prep += document.getElementById('t' + index).value
    ))}
    props.setOutput(prep);
    //console.log(data);
  },[props.search])

  const [selectedValue, setSelectedValue] = useState([]);
  const [cycleIndices, setCycleIndices] = useState({});

  // Reset cycle positions when user retypes the name
  useEffect(() => {
    setCycleIndices({});
  }, [props.originalSearch]);

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
    //props.search = props.search.substring(0, event.target.id.substring(1)) + event.target.value + props.search.substring((event.target.id.substring(1)+1));
    //console.log(props.search.substring(0, event.target.id.substring(1)) + event.target.value + props.search.substring((event.target.id.substring(1)+1)));
    //props.setOutput(props.search.substring(0, event.target.id.substring(1)) + event.target.value + props.search.substring((event.target.id.substring(1)+1)));
    var prep = '';
    {props.search.split('').map((char, index) => (
      prep += document.getElementById('t' + index).value
    ))}
    props.setSearch(prep);
  }

  const handleSingleAuto = (index) => {
    const originalChar = (props.originalSearch || props.search)[index] || props.search[index];
    const cycle = getCycle(originalChar);
    const currentStep = cycleIndices[index] ?? 0;
    const nextStep = (currentStep + 1) % cycle.length;
    setCycleIndices(prev => ({ ...prev, [index]: nextStep }));
    const chars = props.search.split('');
    chars[index] = cycle[nextStep];
    props.setSearch(chars.join(''));
  };

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '2px' }}>
      {props.search.split('').map((letter, index) => (
        <label key={index}>
          <select id={'t'+index} value={letter} onChange={handleChange}>
            {data.map((option, dIndex) => (
              <option key={data[dIndex].Char+dIndex} value={data[dIndex].Char}>{data[dIndex].Char}</option>
            ))}
          </select>
          <button type="button" className="single-auto-btn" onClick={() => handleSingleAuto(index)}>✦</button>
        </label>
      ))}
    </div>
  );
}